if (!customElements.get('jr-quick-buy')) {
  customElements.define('jr-quick-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.m-main-product');
      this.info = this.root?.querySelector('.m-main-product--info');
      this.form = this.info?.querySelector('.m-product-form--main');
      this.button = this.querySelector('button');
      if (!this.form || !this.button) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.queueUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateVisibility(); });
      };
      this.button.addEventListener('click', () => this.goToOptions(), {signal});
      window.addEventListener('scroll', this.queueUpdate, {passive:true, signal});
      window.addEventListener('resize', this.queueUpdate, {passive:true, signal});
      this.observer = new IntersectionObserver(this.queueUpdate);
      this.observer.observe(this.form);
      this.queueUpdate();
    }
    headerOffset() {
      const header = document.querySelector('m-header');
      const height = header?.getBoundingClientRect().height || 0;
      return Math.min(height, innerHeight * 0.32) + 24;
    }
    updateVisibility() {
      const mobile = matchMedia('(max-width:767px)').matches;
      const enabled = this.dataset[mobile ? 'mobile' : 'desktop'] === 'true';
      const rect = this.form.getBoundingClientRect();
      const visible = rect.bottom > this.headerOffset() && rect.top < innerHeight - 64;
      this.hidden = !enabled || scrollY < 240 || visible;
    }
    goToOptions() {
      const picker = this.info.querySelector('variant-picker');
      const target = picker?.querySelector('[data-jr-size-option]') ||
        picker?.querySelector('.m-product-option') || this.info.querySelector('jr-box-size') || this.form;
      this.hidden = true;
      target.setAttribute('tabindex', '-1');
      target.classList.add('jr-purchase-target');
      target.style.scrollMarginTop = this.headerOffset() + 'px';
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth',block:'start'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
